/*
 * Copyright (c) 2023 | All Rights Reserved
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 *  Written by MeeCode by Mario Murrent
 */
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { i18nextPlugin } from 'translation-check';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-xhr-backend';
import en from './locales/en.json';
import de from './locales/de.json';
import { logError, logInfo } from '../utils/Logging';
import axios from 'axios';

export const resources = {
  en: {
    translation: en
  },
  de: {
    translation: de
  }
};

const langDetectorOptions = {
  order: ['cookie', 'localStorage', 'navigator'],

  lookupCookie: 'locale',
  lookupLocalStorage: 'locale',
  caches: ['localStorage', 'cookie'],
  excludeCacheFor: ['cimode'],

  checkWhitelist: true
};

export const initTranslations = async (): Promise<void> => {
  try {
    const enResponse = await axios.get('https://region-im-netz.at/locales/en/translation.json');
    const deResponse = await axios.get('https://region-im-netz.at/locales/de/translation.json');
    resources.en.translation = enResponse.data;
    resources.de.translation = deResponse.data;
  } catch (error) {
    logInfo('Error loading translations from server, using local translations');
  }
  i18n
    .use(Backend)
    .use(i18nextPlugin)
    .use(initReactI18next)
    .use(LanguageDetector)
    .init({
      resources,
      lng: 'de',
      fallbackLng: 'de',
      keySeparator: '.',
      detection: langDetectorOptions,
      interpolation: {
        escapeValue: false
      },
      backend: {
        loadPath: 'https://region-im-netz.at/locales/{{lng}}/translation.json',
        cors: true
      }
    }).catch(logError);
};

export default i18n;
